import React from 'react';
import type { ManagementSearchToolbarProps } from '../types';

const ManagementSearchToolbar = ({
  searchQuery,
  onSearchChange,
  totalCount,
  visibleCount,
  entityLabel,
  placeholder,
  actions,
  className = '',
}: ManagementSearchToolbarProps) => {
  return (
    <div className={`app-toolbar p-3 border-bottom ${className}`.trim()}>
      <div className="input-group app-search">
        <span className="input-group-text">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path><path d="M21 21l-6 -6"></path></svg>
        </span>
        <input
          type="text"
          className="form-control"
          placeholder={placeholder}
          value={searchQuery}
          onChange={(event) => onSearchChange(event.target.value)}
        />
        {searchQuery && (
          <button className="btn btn-outline-secondary" type="button" onClick={() => onSearchChange('')}>
            x
          </button>
        )}
      </div>
      {actions && <div className="d-flex align-items-center gap-2 flex-wrap">{actions}</div>}
      <small className="text-muted text-nowrap ms-auto">
        {totalCount !== null ? `${visibleCount} / ${totalCount} ${entityLabel}` : `${visibleCount} ${entityLabel}`}
      </small>
    </div>
  );
};

export default ManagementSearchToolbar;
